import { render, staticRenderFns } from "./projectlist.vue?vue&type=template&id=4b5468f7&scoped=true&"
import script from "./projectlist.vue?vue&type=script&lang=js&"
export * from "./projectlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5468f7",
  null
  
)

export default component.exports